import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f68ee10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "visualization",
  id: "visualization"
}
const _hoisted_2 = { class: "visualization_content" }
const _hoisted_3 = { class: "dragArea" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragArea_bubble_arrow" }, null, -1))

import { defineAsyncComponent, ref, shallowRef } from 'vue';
import draggable from 'vuedraggable';
import emitter from '@/utils/mitt';
import http from '@/api/conentCenter/communal';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { useDebounce } from '@/hooks/useDebounce';
import https from '@/api/live';
import CDelModal from '@/components/CDelModal.vue';
import moment from 'moment';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'Visualization',
  setup(__props, { expose }) {

const TopBar = defineAsyncComponent(() => import('./components/TopBar.vue'));
const RotationChart = defineAsyncComponent(() => import('./components/RotationChart.vue'));
const MyLive = defineAsyncComponent(() => import('./components/MyLive.vue'));
const CubeNav = defineAsyncComponent(() => import('./components/cubeNav.vue'));
const MyArticle = defineAsyncComponent(() => import('./components/MyArticle.vue'));
const MyImages = defineAsyncComponent(() => import('./components/MyImages.vue'));
const Horizontal = defineAsyncComponent(() => import('./components/Horizontal.vue'));
const Living = defineAsyncComponent(() => import('./components/Living.vue'));
const Fold = defineAsyncComponent(() => import('./components/Fold.vue'));

const route = useRoute();
const gatewayId = route.params.gatewayId;

const componentList = shallowRef([
  {
    type: 0,
    component: RotationChart,
  },
  {
    type: 1,
    component: CubeNav,
  },
  {
    type: 2,
    component: Living,
  },
  {
    type: 3,
    component: MyArticle,
  },
  {
    type: 4,
    component: MyImages,
  },
  {
    type: 5,
    component: MyLive,
  },
  {
    type: 6,
    component: Horizontal,
  },
  {
    type: 7,
    component: Fold,
  },
]);

const emptyList = ref([
  {
    type: 0,
    name: '轮播图',
    icon: 'rotationChart',
    rotationChart: {
      type: 0,
      interval: 3000,
      indicatorType: 0,
    },
    rotationChartList: [
      {
        id: 0,
        img: '',
        loading: false,
        type: 0,
        imgId: 0,
        jump: {
          content: false,
          title: '',
          titleColor: '#16B9FA',
          subtitle: '',
          subtitleColor: '#16B9FA',
          profiles: '',
          btn: false,
          btnColor: '#16B9FA',
          btnName: '查看',
          btnNameColor: '#FFF',
          link: false,
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
          timing: false,
          startTime: moment(new Date()),
          endTime: moment(new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000)),
        },
      },
    ],
  },
  {
    type: 1,
    name: '魔方导航',
    icon: 'navigation',
    content: {
      navType: 0,
      title_type: 0,
      radius_type: 1,
      title_color: '#505D6F',
      title_default_color: '',
    },
    navList: [
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#DCDFE6',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#617EFE',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#FF5F5F',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#00CCB0',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
      {
        icon: '',
        icon_type: 0,
        title_type: false,
        title: '默认文字',
        bg_type: 0,
        default_bg_color: '#DCDFE6',
        bg_color: '#19BDFF',
        bg_img: '',
        jump_type: 0,
        jump_link: '',
        jump: {
          jump: 0, //0站内，1站外
          insideLink: undefined,
          inSpecificLink: undefined,
          outsideLink: '',
        },
      },
    ],
  },
]);
const visualizationList: any = ref([]);

const topBar = ref({
  type: -1,
  name: '顶部栏装修',
  titleList: [],
});

expose({
  visualizationList,
});
// 点击模块事件
const clickId = ref(-1);
const clickList = (res: any, index: number) => {
  clickId.value = index;
  emitter.emit('custom', res);
  emitter.emit('cubnavInfo', { type: res.type, index: index });
  emitter.emit('display', true);
  if (index !== 6 && index !== 7) {
    emitter.emit('resetModule', false);
  }
};

// 删除模块
const deleteModal = ref(false);
const deleteIndex = ref(0);
const deleteList = (index: number) => {
  deleteModal.value = true;
  deleteIndex.value = index;
};
const deteleSelect = () => {
  visualizationList.value.splice(deleteIndex.value, 1);
  deleteModal.value = false;
  clickList(topBar.value, -1);
};
const closeModal = () => {
  deleteModal.value = false;
};

// 当前组件拖拽
const getEnd = async (e: any) => {
  const reset = await resetList(e);
  if (reset) {
    clickId.value = e.newIndex;
    emitter.emit('custom', visualizationList.value[e.newIndex]);
  }
};
// 其他组件拖拽克隆
const getAdd = async (e: any) => {
  await resetList(e);
  clickId.value = e.newIndex;
  emitter.emit('custom', visualizationList.value[e.newIndex]);
  emitter.emit('cubnavInfo', { type: visualizationList.value[e.newIndex].type, index: e.newIndex });
};

// 首个轮播图、魔方导航置顶
const resetList = (e: any) => {
  return new Promise((resolve) => {
    message.destroy();
    const RotationChartFind = visualizationList.value.findIndex((item: any) => {
      return item.type == 0;
    });
    const navigation = visualizationList.value.findIndex((item: any) => {
      return item.type == 1;
    });
    let copeList = visualizationList.value;
    const RotationChartFindList = visualizationList.value[RotationChartFind];
    const navigationList = visualizationList.value[navigation];
    //同时存在轮播图和魔方导航
    if (RotationChartFind !== -1 && navigation !== -1) {
      delete copeList[RotationChartFind];
      delete copeList[navigation];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 1 && e.newIndex > 1 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(RotationChartFindList);
      visualizationList.value.splice(1, 0, navigationList);
      e.oldIndex > 1 && e.newIndex <= 1 ? message.info('首个轮播图、魔方导航置顶') : '';
    } //仅存在轮播图
    else if (RotationChartFind !== -1) {
      delete copeList[RotationChartFind];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 0 && e.newIndex > 0 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(RotationChartFindList);
      e.oldIndex > 0 && e.newIndex < 1 ? message.info('首个轮播图置顶') : '';
    } //仅存在魔方导航
    else if (navigation !== -1) {
      delete copeList[navigation];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 0 && e.newIndex > 0 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(navigationList);
      e.oldIndex > 0 && e.newIndex < 1 ? message.info('首个魔方导航置顶') : '';
    }
    const type = visualizationList.value[e.oldIndex].type;
    if (e.oldIndex == 0 && type == 0) {
      message.info('置顶轮播图不可拖拽');
    } else if ((e.oldIndex == 0 && type == 1) || (e.oldIndex == 1 && type == 1)) {
      message.info('置顶魔方导航不可拖拽');
    }
  });
};
emitter.on('modalIndex', (e: any) => {
  clickList(visualizationList.value[e], e);
});
emitter.on('visualization', (e: any) => {
  visualizationList.value[clickId.value] = e;
});
emitter.on('topBar', (e: any) => {
  topBar.value = e;
});

emitter.on('visualizationList', (e: any) => {
  visualizationList.value = e;
});
// 获取门户信息
const getPortalInfo = useDebounce(() => {
  http.getPortalInfo({ params: { portal_id: gatewayId } }).then(async (res) => {
    const resData = res.data.data;
    if (res.data.code == 200) {
      let list = resData.config ? JSON.parse(resData.config).visualizationList : [];
      if (typeof list == 'object') {
        list = Object.values(list);
      }
      visualizationList.value = resData.config && list.length > 0 ? list : emptyList.value;
      resData.config ? (topBar.value = JSON.parse(resData.config).topBar) : '';
      visualizationList.value = await assignmentLive();
      clickList(topBar.value, -1);
      emitter.emit('title', resData.name);
    }
  });
});
getPortalInfo();

// 剔除空状态
let rejectList: any;
const deleteEmpty = () => {
  rejectList = JSON.parse(JSON.stringify(visualizationList.value));
  rejectList.map((res: any, index: number) => {
    rejectList = deleteEmptyList(res, index, rejectList);
  });
  rejectList = rejectList.filter((res: any) => res !== null);
  return rejectList;
};
const deleteEmptyList = (res: any, index: number, list: any) => {
  switch (res.type) {
    case 0:
      res.rotationChartList = res.rotationChartList.filter((res: any) => res.img);
      res.rotationChartList.length == 0 ? delete list[index] : '';
      break;
    case 1:
      if (res.content.navType == 0) {
        const navList = res.navList.filter((item: any) => {
          return item.icon || item.title !== '默认文字' || item.bg_type == 2;
        });
        navList.length == 0 ? delete list[index] : '';
      }
      break;
    case 2:
      res.length = res.liveList.length;
      break;
    case 3:
      res.articleList = res.articleList.filter((res: any) => res.title);
      res.articleList.length == 0 ? delete list[index] : '';
      res.length = res.articleList.length;
      break;
    case 4:
      res.imgList = res.imgList.filter((res: any) => res.url);
      res.imgList.length == 0 ? delete list[index] : '';
      res.length = res.imgList.length;
      break;
    case 5:
      res.liveList[0].image_player_cover_url ? '' : delete list[index];
      res.length = res.liveList.length;
      break;
    case 6:
    case 7:
      res.tabsList.map((item: any, index: number) => {
        res.tabsList = deleteEmptyList(item.nestedList[0], index, res.tabsList);
      });
      res.tabsList = res.tabsList.filter((res: any) => res !== null && res.nestedList[0].type);
      res.tabsList.length == 0 ? delete list[index] : '';
      break;
  }
  return list;
};

/**
 * 过滤字符串 转移 " \
 */
const filterStr = (str: string) => {
  var re = new RegExp('"', 'g');
  var fxg = new RegExp('\\\\', 'g');
  str = str.replace(fxg, '\\\\');
  str = str.replace(re, '\\"');
  return str;
};
const jsonStr = (res: any) => {
  switch (res.type) {
    case 0:
      res.rotationChartList.map((e: any) => {
        e.jump.title = filterStr(e.jump.title);
        e.jump.subtitle = filterStr(e.jump.subtitle);
        e.jump.profiles = filterStr(e.jump.profiles);
        e.jump.btnName = filterStr(e.jump.btnName);
        e.jump.outsideLink = filterStr(e.jump.outsideLink);
      });
      break;
    case 1:
      res.navList.map((e: any) => {
        e.title ? (e.title = filterStr(e.title)) : '';
        e.icon ? (e.icon = filterStr(e.icon)) : '';
        e.jump_link = filterStr(e.jump_link);
        e.jump ? (e.jump.outsideLink = filterStr(e.jump.outsideLink)) : '';
      });
      break;
    case 2:
    case 5:
      res.title = filterStr(res.title);
      res.liveList.map((e: any) => {
        e.title = filterStr(e.title);
      });
      break;
    case 3:
      res.title = filterStr(res.title);
      if (res.articleList[0].article_kv) {
        res.articleList.map((e: any) => {
          e.content = filterStr(e.content);
          e.title = filterStr(e.title);
          e.sort_name = filterStr(e.sort_name);
          e.publisher = filterStr(e.publisher);
        });
      }
      break;
    case 4:
      res.content.title = filterStr(res.content.title);
      break;
  }
};
// 编辑/保存
const getPortal = useDebounce(async () => {
  message.destroy();
  const visualizationList = await deleteEmpty();
  visualizationList.map((e: any) => {
    if (e.type == 6 || e.type == 7) {
      e.type == 7 ? (e.title = filterStr(e.title)) : '';
      e.tabsList.map((a: any) => {
        a.title = filterStr(a.title);
        a.nestedList.map((b: any) => {
          jsonStr(b);
        });
      });
      return;
    }
    jsonStr(e);
  });
  const config = {
    visualizationList,
    topBar: topBar.value,
  };
  const data = {
    portal_id: gatewayId,
    config: JSON.stringify(config),
  };
  http.editPortal(data).then((res) => {
    if (res.data.code == 200) {
      message.success('保存成功');
      getPortalInfo();
    }
  });
});
emitter.on('crumb', () => {
  getPortal();
});

// 获取正在直播
const liveList: any = ref([]);
const getLiveList = () => {
  const search = {
    page: 1,
    page_num: 5,
    status: 4,
    status_order: 1,
    sub_studio: 0,
  };
  https.getLiveList({ params: search }).then((res: any) => {
    const resData = res.data.data;
    if (resData.data.length == 0) {
      liveList.value = [
        {
          id: 0,
          style: 0,
          image_player_cover_url: '',
          mode: null,
          start_at: '',
          status: null,
          title: '',
          number: null,
          live_url_status: null,
        },
      ];
    } else {
      liveList.value = [...resData.data];
    }
    emitter.emit('liveList', liveList.value);
  });
};
getLiveList();
// 处理正在直播、我的直播
const assignmentLive = () => {
  return new Promise((resolve) => {
    visualizationList.value.map((res: any) => {
      switch (res.type) {
        case 2:
        case 5:
          res.liveList.map((item: any) => (item.style = res.style));
          break;
        case 6:
        case 7:
          res.tabsList.map((titem: any) => {
            if (titem.nestedList[0].type == 2 || titem.nestedList[0].type == 5) {
              titem.nestedList[0].liveList.map((item: any) => {
                item.style = titem.nestedList[0].style;
              });
            }
          });
          break;
      }
    });
    resolve(visualizationList.value);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(TopBar), {
        class: _normalizeClass(clickId.value == -1 ? 'dragArea_border_click' : 'dragArea_border'),
        component: topBar.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickList(topBar.value, -1)))
      }, null, 8, ["class", "component"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(draggable), {
            list: visualizationList.value,
            group: { name: 'subassembly' },
            "item-key": "index",
            handle: ".dragArea_bubble",
            animation: 150,
            onEnd: getEnd,
            onAdd: getAdd,
            onDrop: _unref(dragDrop),
            class: "visualization_content_draggable"
          }, {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(clickId.value == index ? 'dragArea_border_click' : 'dragArea_border'),
                  onClick: ($event: any) => (clickList(element, index))
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentList)[element.type].component), {
                    component: element,
                    Index: index
                  }, null, 8, ["component", "Index"])),
                  _createElementVNode("div", {
                    class: _normalizeClass(["dragArea_bubble", clickId.value == index ? 'dragArea_bubble_click' : ''])
                  }, [
                    _hoisted_5,
                    _createElementVNode("div", null, _toDisplayString(element.name), 1),
                    _createVNode(_component_svg_icon, {
                      onClick: ($event: any) => (deleteList(index)),
                      "icon-class": "delete_circular_click"
                    }, null, 8, ["onClick"])
                  ], 2)
                ], 10, _hoisted_4)
              ])
            ]),
            _: 1
          }, 8, ["list", "onDrop"])
        ])
      ])
    ]),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: closeModal,
      ok: deteleSelect
    }, null, 8, ["visible"])
  ], 64))
}
}

})